import { Dispatch, SetStateAction, useState } from 'react';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { createUploadUrlForRentRequestsDocument } from '@api/assetsRentDocuments';
import { uploadFileToGcloud } from '@api/common';

import { handleErrorFromMessage } from '@utils/handleRequestError';
import { generateHeaders } from '@utils/headersMapper';

import { IAssetFile } from '@interfaces/assets/asset';

import { ESnackbarTypes, TMIMETypes } from '@enums/common';

import { HUNDRED_PERCENT_LOADING } from '@constants/common';
import { UPLOAD_URL_ATTACHMENT } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

interface IUseAttachFilesParams {
	setUploadedFiles: Dispatch<SetStateAction<Array<IAssetFile>>>;
	requestId: string;
	setIsDirtyForm: (isDirty: boolean) => void;
}

export const useMutateCreateUrlForRequestDocument = (props: IUseAttachFilesParams) => {
	const [progress, setProgress] = useState<number>(HUNDRED_PERCENT_LOADING);

	const { setUploadedFiles, requestId, setIsDirtyForm } = props;

	const dispatch = useAppDispatch();

	const { mutate: createUploadUrlAttachment } = useMutation({
		mutationKey: [UPLOAD_URL_ATTACHMENT],
		mutationFn: ({ files }: { files: Array<File> }) => {
			files.forEach((file) => {
				createUploadUrlForRentRequestsDocument({ fileName: file.name, requestId }).then((data: any) => {
					const headers = generateHeaders(data?.headers);
					const url = data?.uploadUrl;

					uploadFileToGcloud({ url, data: file, headers, onProgressHandler: setProgress }).then(() => {
						setIsDirtyForm(true);
						setUploadedFiles(prevState => ([...prevState, {
							name: file.name,
							id: data.importId,
							size: file.size,
							mimeType: file.type as TMIMETypes,
						}]));
					}).catch((err) => {
						dispatch(setSnackbar({
							message: err?.message || responseMessages.error,
							type: ESnackbarTypes.error,
						}));
					});
				}).catch(err => handleErrorFromMessage(err));
			});
		},
	});

	return {
		createUploadUrlAttachment,
		progress,
	};
};
